import { useMutation, useQueryClient } from 'react-query';

import { axios } from 'lib/axios';

const markRead = ({ notificationID }) => {
  return axios.put(`/api/notifications/${notificationID}/read`);
};

const markAllRead = () => {
  return axios.put('/api/notifications/read_all');
};

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markRead,
    onSuccess: () => queryClient.invalidateQueries('notifications'),
  });
};

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markAllRead,
    onSuccess: () => queryClient.invalidateQueries('notifications'),
  });
};
